import React, { useEffect } from "react";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import MyNominationCard from "./MyNominationCard";
import { Pagination } from "antd";
import { getEmployeeAwardList } from "../../../../../redux/employeeaward/employeeAwardState";

const RecentNominationSummary = ({
  recordList, 
  pagination, 
  filters, 
  doSearch,
}) => {

  useEffect(() => {
    doSearch({ paginate: pagination?.per_page || 10 });
  }, [doSearch, pagination?.per_page]);

  return (
    <HeaderComponent
      title="Recent Nominations"
      titleClass="text-[16px] font-medium"
      description="Track the status of your award nominations"
      descriptionClass="text-sm muted-text"
      cardBorder="border"
    >
      <div className="max-h-[600px] overflow-y-auto pr-2">
        <MyNominationCard 
          recordList={recordList} 
        />

        {pagination?.total > pagination?.per_page && (
          <div className="flex justify-end py-4">
            <Pagination
              current={pagination?.current_page}
              pageSize={pagination?.per_page}
              total={pagination?.total}
              showSizeChanger={false}
              onChange={(page) =>
                doSearch({
                  ...filters,
                  page,
                  paginate: pagination?.per_page,
                })
              }
            />
          </div>
        )}
      </div>
    </HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.employeeAward.employeeAwardList?.items,
  pagination: state.employeeAward.employeeAwardList?.pagination,
  filters: state.employeeAward.employeeAwardList?.filters,
  requesting: state.employeeAward.employeeAwardList?.requesting,
  error: state.employeeAward.employeeAwardList?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getEmployeeAwardList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecentNominationSummary);